import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import styles from './resources.module.scss';
import NormalTopBanner from '../Common/TopBanner/NormalTopBanner';
import { USAMap } from '@mirawision/usa-map-react';
import { Flex, GeneralTile, Button } from '../../ui';
import { Link } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DomainAddIcon from '@mui/icons-material/DomainAdd';

const Tooltip = ({ text, x, y }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: y,
        left: x,
        backgroundColor: 'black',
        color: 'white',
        padding: '5px',
        borderRadius: '5px',
        zIndex: 1,
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: text }}></span>
    </div>
  );
};

const UseByState = () => {
  const stateVals = {
    AL: 'YES',
    AK: 'YES',
    AZ: 'YES',
    AR: 'YES',
    CA: 'YES',
    CO: 'YES',
    CT: 'YES',
    DE: 'YES',
    DC: 'YES',
    FL: 'YES',
    GA: 'NO',
    HI: 'NO',
    ID: 'NO',
    IL: 'YES',
    IN: 'YES',
    IA: 'YES',
    KS: 'YES',
    KY: 'YES',
    LA: 'YES',
    ME: 'YES',
    MD: 'YES',
    MA: 'YES',
    MI: 'YES',
    MN: 'YES',
    MS: 'YES',
    MO: 'YES',
    MT: 'NO',
    NE: 'YES',
    NV: 'NO',
    NH: 'YES',
    NJ: 'YES',
    NM: 'YES',
    NY: 'YES',
    NC: 'YES',
    ND: 'NO',
    OH: 'YES',
    OK: 'YES',
    OR: 'YES',
    PA: 'YES',
    RI: 'YES',
    SC: 'YES',
    SD: 'YES',
    TN: 'YES',
    TX: 'YES',
    UT: 'YES',
    VT: 'YES',
    VA: 'YES',
    WA: 'YES',
    WV: 'YES',
    WI: 'YES',
    WY: 'NO',
  };
  const stateNames = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  };
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [tooltipText, setTooltipText] = useState(null);

  const [isStateOrganizationOpened, setIsStateOrganizationOpened] = useState(false);

  const handlerMouseOver = (e, state) => {
    if (tooltipText == null) {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setTooltipText(`${stateNames[state] ? stateNames[state] : state}`);
      setTooltipVisible(true);
    }
  };
  const handlerMouseOut = (e) => {
    setTooltipText(null);
    setTooltipVisible(false);
  };

  useEffect(() => {
    Object.keys(stateVals).forEach((state) => {
      const elem = document.querySelector(`.usa-state.${state.toLocaleLowerCase()}`);
      if (elem) {
        elem.addEventListener('mouseover', (e) => handlerMouseOver(e, state));
        elem.addEventListener('mouseout', handlerMouseOut);
      }
    });
  }, []);

  const getRedHexColor = (value) => {
    // Return the hex color string in the format '#RRGGBB'
    return value === 'YES' ? `#671E75` : `#FFF`;
  };

  const getCustomStates = () => {
    const customStates = {};
    Object.keys(stateVals).forEach((stateKey) => {
      customStates[stateKey] = {
        fill: getRedHexColor(stateVals[stateKey]),
      };
    });
    return customStates;
  };
  const customStates = getCustomStates();

  return (
    <div className={styles.Toolkits}>
      <NormalTopBanner>
        <h1>AHRQ Quality Indicator Usage Across States</h1>
        <p>
          This heatmap illustrates the usage of AHRQ Quality Indicators (AHRQ QIs) across the United
          States. Explore which states are leveraging these evidence-based measures to assess and
          improve healthcare quality.
        </p>
      </NormalTopBanner>
      <div className={`bg-primary-blue-6 my-5`}>
        <Container className={`outer-container ${styles.Panel}`}>
          <Flex flexDirection={{ xs: 'column', md: 'row' }} gap={2} pt={1}>
            <div style={{ flex: '6', display: 'flex' }}>
              <Flex className='text-center block my-auto' flexDirection={{ xs: 'column' }} gap={2}>
                <USAMap customStates={customStates} />
                <div>
                  <p className='font-normal'>
                    If your state is using AHRQ QIs and you would like to update the map or share
                    how you are using them, please contact us via email -{' '}
                    <a href='mailto:QISupport@ahrq.hhs.gov' className='bold'>
                      QISupport@ahrq.hhs.gov
                    </a>
                    .
                  </p>
                </div>
              </Flex>
            </div>
            <div style={{ flex: '3' }}>
              <GeneralTile type='general'>
                <Flex className='font-normal' flexDirection={{ xs: 'column' }} gap={2} pt={1}>
                  <p className='mb-0 bold'>How states use QIs</p>
                  <div className='flex flex-row'>
                    <div>
                      <AccountBalanceIcon className='mr-2' />
                    </div>
                    <div>
                      <span className='bold'>State agencies</span> use quality indicators to:
                      <ul>
                        <li>Evaluate resource needs and healthcare access in communities</li>
                        <li>Assess service quality</li>
                        <li>Inform policy development on care availability and accessibility</li>
                      </ul>
                    </div>
                  </div>
                  <div className='flex flex-row'>
                    <div>
                      <DomainAddIcon className='mr-2' />
                    </div>
                    <div>
                      <span className='bold'>State hospital associations</span> use quality
                      indicators to:
                      <ul>
                        <li>Identify areas for care improvement</li>
                        <li>Guide patient and family outreach programs</li>
                        <li>
                          Develop educational initiatives for high-utilization conditions and
                          improved outcomes
                        </li>
                      </ul>
                    </div>
                  </div>
                </Flex>
              </GeneralTile>
            </div>
          </Flex>
        </Container>
      </div>
      <div>
        <Container className='outer-container'>
          <div className='text-center mb-5'>
            <h2>Acknowledgement</h2>
          </div>
          <p>
            The Agency for Healthcare Research and Quality (AHRQ) Quality Indicators (QI) program
            uses the Healthcare Cost and Utilization Project (HCUP) State Inpatient Databases (SID)
            and State Emergency Department Databases (SEDD) for the development of the AHRQ QIs,
            using the databases as the reference (general or standard) population.
          </p>
          <p>
            The AHRQ QI program would like to acknowledge the{' '}
            <span>
              <Link
                to={{ pathname: 'https://hcup-us.ahrq.gov/db/hcupdatapartners.jsp' }}
                aria-label='https://hcup-us.ahrq.gov/db/hcupdatapartners.jsp'
                target='_blank'
                rel='noreferrer'
              >
                <span>HCUP Partner organizations</span>
                <img
                  alt='external web link policy'
                  style={{ marginLeft: 4 }}
                  src='/images/exit_disclaimer.png'
                />
              </Link>{' '}
              that participated in the HCUP SID and SEDD.
            </span>
          </p>
          <p>
            {isStateOrganizationOpened ? (
              <Button
                label={`Close state organizations`}
                variant='text'
                sx={{ fontWeight: 700 }}
                className='px-0'
                onClick={() => setIsStateOrganizationOpened(false)}
                arrowDropDown
              />
            ) : (
              <Button
                label={`View state organizations`}
                variant='text'
                sx={{ fontWeight: 700 }}
                className='px-0'
                onClick={() => setIsStateOrganizationOpened(true)}
                arrowRight
              />
            )}
          </p>
          {isStateOrganizationOpened && (
            <p>
              <span className='bold'>Alaska</span> Department of Health,{' '}
              <span className='bold'>Alaska</span> Hospital and Healthcare Association,{' '}
              <span className='bold'>Arizona</span> Department of Health Services,{' '}
              <span className='bold'>Arkansas</span> Department of Health,{' '}
              <span className='bold'>California</span> California Department of Health Care Access
              and Information, <span className='bold'>Colorado</span> Hospital Association,{' '}
              <span className='bold'>Connecticut</span> Hospital Association,{' '}
              <span className='bold'>Delaware</span> Division of Public Health,{' '}
              <span className='bold'>District of Columbia</span> Hospital Association,{' '}
              <span className='bold'>Florida</span> Agency for Health Care Administration,{' '}
              <span className='bold'>Georgia</span> Hospital Association,{' '}
              <span className='bold'>Hawaii</span> Laulima Data Alliance,{' '}
              <span className='bold'>Hawaii</span> University of Hawaii at Hilo,{' '}
              <span className='bold'>Illinois</span> Department of Public Health,{' '}
              <span className='bold'>Indiana</span> Hospital Association,{' '}
              <span className='bold'>Iowa</span> Hospital Association,{' '}
              <span className='bold'>Kansas</span> Hospital Association,{' '}
              <span className='bold'>Kentucky</span> Cabinet for Health and Family Services,{' '}
              <span className='bold'>Louisiana</span> Department of Health,{' '}
              <span className='bold'>Maine</span> Health Data Organization,{' '}
              <span className='bold'>Maryland</span> Health Services Cost Review Commission,{' '}
              <span className='bold'>Massachusetts</span> Center for Health Information and
              Analysis, <span className='bold'>Michigan</span> Health & Hospital Association,{' '}
              <span className='bold'>Minnesota</span> Hospital Association,{' '}
              <span className='bold'>Mississippi</span> State Department of Health,{' '}
              <span className='bold'>Missouri</span> Hospital Industry Data Institute,{' '}
              <span className='bold'>Montana</span> Hospital Association,{' '}
              <span className='bold'>Nebraska</span> Hospital Association,{' '}
              <span className='bold'>Nevada</span> Department of Health and Human Services,{' '}
              <span className='bold'>New Hampshire</span> Department of Health & Human Services,{' '}
              <span className='bold'>New Jersey</span> Department of Health,{' '}
              <span className='bold'>New Mexico</span> Department of Health,{' '}
              <span className='bold'>New York</span> State Department of Health,{' '}
              <span className='bold'>North Carolina</span> Department of Health and Human Services,{' '}
              <span className='bold'>North Dakota</span> (data provided by the{' '}
              <span className='bold'>Minnesota</span> Hospital Association),{' '}
              <span className='bold'>Ohio</span> Hospital Association,{' '}
              <span className='bold'>Oklahoma</span> State Department of Health,{' '}
              <span className='bold'>Oregon</span> Association of Hospitals and Health Systems,{' '}
              <span className='bold'>Oregon</span> Health Authority,{' '}
              <span className='bold'>Pennsylvania</span> Health Care Cost Containment Council,{' '}
              <span className='bold'>Rhode Island</span> Department of Health,{' '}
              <span className='bold'>South Carolina</span> Revenue and Fiscal Affairs Office,{' '}
              <span className='bold'>South Dakota</span> Association of Healthcare Organizations,{' '}
              <span className='bold'>Tennessee</span> Hospital Association,{' '}
              <span className='bold'>Texas</span> Department of State Health Services,{' '}
              <span className='bold'>Utah</span> Department of Health,{' '}
              <span className='bold'>Vermont</span> Association of Hospitals and Health Systems,{' '}
              <span className='bold'>Virginia</span> Health Information,{' '}
              <span className='bold'>Washington</span> State Department of Health,{' '}
              <span className='bold'>West Virginia</span> Department of Health and Human Resources,{' '}
              <span className='bold'>Wisconsin</span> Department of Health Services, and{' '}
              <span className='bold'>Wyoming</span> Hospital Association.{' '}
            </p>
          )}
          <p>
            For more information on HCUP, visit{' '}
            <Link
              to={{ pathname: 'https://www.hcup-us.ahrq.gov' }}
              aria-label='For more information on HCUP visit https://www.hcup-us.ahrq.gov'
              target='_blank'
              rel='noreferrer'
            >
              <span>https://www.hcup-us.ahrq.gov</span>
              <img
                alt='external web link policy'
                style={{ marginLeft: 4 }}
                src='/images/exit_disclaimer.png'
              />
            </Link>
            .{' '}
          </p>
        </Container>
      </div>
      <div className=''>
        {tooltipVisible && <Tooltip text={tooltipText} x={mousePosition.x} y={mousePosition.y} />}
      </div>
    </div>
  );
};

export default UseByState;
